// extracted by mini-css-extract-plugin
export default {"custom-notification-badge":"NewUsedCouponsBadge_custom-notification-badge__6NmH1"};